import { createSlice } from '@reduxjs/toolkit';

import type {
  FetchTestimonialsSuccessAction,
  TestimonialsStateType,
} from './types';

const initialState: TestimonialsStateType = {
  fetching: false,
  data: [],
};

const testimonialsSlice = createSlice({
  name: 'testimonials',
  initialState,
  reducers: {
    fetchTestimonials: (state) => ({
      ...state,
      fetching: true,
    }),
    fetchTestimonialsSuccess: (
      state,
      { payload }: FetchTestimonialsSuccessAction,
    ) => {
      const { data: loaded, append } = payload;
      const oldData = state.data;

      return {
        ...state,
        data: append ? oldData.concat(loaded) : loaded,
        fetching: false,
      };
    },
    fetchTestimonialsFail: (state) => ({
      ...state,
      fetching: false,
    }),
  },
});

export const { name } = testimonialsSlice;
export const {
  fetchTestimonials,
  fetchTestimonialsSuccess,
  fetchTestimonialsFail,
} = testimonialsSlice.actions;

export default testimonialsSlice.reducer;
